@if (loading()) {
  <div class="home__loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
} @else if (loadError()) {
  <div class="home__empty" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ 'home.projects.loadError' | translate }}</span>
  </div>
} @else {
  <div class="home__wrapper">
    <div class="home__page-header" data-testid="startseite-begruessung">
      <div class="home__page-eyebrow">{{ 'home.welcome.eyebrow' | translate }}</div>
      <h1 class="home__page-title">
        @if (firstName(); as name) {
          {{ 'home.welcome.title' | translate: { name } }}
        } @else {
          {{ 'home.welcome.titleNoName' | translate }}
        }
      </h1>
      @let subtitle = welcomeSubtitle();
      <p class="home__page-subtitle">{{ subtitle.key | translate: subtitle.params }}</p>
    </div>

    <app-dash-abschnitt abschnittId="arbeit" [titel]="'home.abschnitte.arbeit' | translate" [first]="true">
      <ng-template>
        <div class="home__arbeit">
          @if (aufgabenSichtbar()) {
            <app-meine-aufgaben-card />
          }
          <app-meine-projekte />
        </div>
      </ng-template>
    </app-dash-abschnitt>

    <app-dash-abschnitt abschnittId="auswertung" [titel]="'home.abschnitte.auswertung' | translate">
      <ng-template>
        <app-dashboard-page />
      </ng-template>
    </app-dash-abschnitt>

    <app-dash-abschnitt abschnittId="arbeitsbereiche" [titel]="'home.workspaces.title' | translate">
      <ng-template>
        <div [class]="tileGridClass()">
          @for (tile of tiles(); track tile.link) {
            <app-nav-tile
              [link]="tile.link"
              [icon]="tile.icon"
              [titleKey]="tile.titleKey ?? ''"
              [titleText]="tile.titleText"
              [subtitleKey]="tile.subtitleKey"
              [stats]="tile.stats"
              [testId]="tile.testId"
            ></app-nav-tile>
          }
        </div>
      </ng-template>
    </app-dash-abschnitt>
  </div>
}
<router-outlet></router-outlet>
